module.exports = __webpack_public_path__ + "media/images/emblems/Saubraz-coat_of_arms-3f2d2817103813429bad5d4c6c6d117b.svg";